/* Pick-реквизит */
(function ($) {
  function DropDownList(inp, img, hidd, keyvalues, opt, placeholder) {
    this.init(inp, img, hidd, keyvalues, opt, placeholder);
  }
  DropDownList.prototype = {
    inp: null,
    img: null,
    hidd: null,
    results: null,
    initValue: null,
    prevValue: null,

    _isShown: false,

    onAfterChange: null,

    keyvalues: [],

    // Инициализация класса.
    //  inp - текстовое поле элемента.
    //  img - иконка календаря, по которой откроется выбор.
    //  hidd - скрытое поле для хранения ключа выбранного значения.
    //  keyvalues - список значений и ключей.
    //  opt - дополнительные настройки (например, onAfterChange).
    init: function (inp, img, hidd, keyvalues, opt, placeholder) {
 
      var me = this;
      me.inp = inp;
      me.img = img;
      me.hidd = hidd;
      me.initValue = hidd.val();
      me.prevValue = me.initValue;
      me.keyvalues = keyvalues;
      me.filterPlaceholder = (!!placeholder) ? placeholder : L("PLEASE_INPUT_VALUE");

      $.extend(me, opt);
      
      // Проверяем была ли инициализация или нет.
      if (!me.inp.data('initComplete')) {
        // Инициализиуем текстовое поле.        
        if (!me.inp.hasClass('editable')) {
          me.inp.bind('click.DropDownList', function (ev) {
            ev.stopPropagation();
            if (me._isShown) me.hide();
            else me.show();
          });
          
          me.inp.prop('readonly', true);
        } else {
          me.addPlaceholder();
          me.inp.on('change.DropDownList', function () {
            me.hidd.val("-1");
          });
        };

        // Инициализация событий клавиатуры.        
        me.inp.bind('keydown.DropDownList', me, me.keyPress);        

        // Инициализиуем иконку.        
        if (me.img) me.img.bind('click.DropDownList', function (ev) {
          ev.stopPropagation();
          if (me._isShown) me.hide();
          else me.show();
        });

        // Скрытие вариантов при click на любое другое место.
        setTimeout(function () { $('body').bind('click.DropDownList', function (ev) { me.hide(); }); }, 1000);
        setTimeout(function () { try { $('iframe').contents().find('body').bind('click.DropDownList', function (ev) { me.hide(); }); } catch (e) { } }, 1000);
        setTimeout(function () { try { $('iframe').contents().find('ftameset').bind('click.DropDownList', function (ev) { me.hide(); }); } catch (e) { } }, 1000);
        setTimeout(function () { $('.ui-dialog-titlebar-close').bind('click.DropDownList', function (ev) { me.hide(); }); }, 1000); //Крестик в модалке. Отчего-то он особый. Замечание #4683153

        // Инициализация завершена.
        me.inp.data('initComplete', true);
      }
    },

    addPlaceholder: function () {
      var me = this;
      me.inp.focus(function () {
        if ($(this).val() == me.filterPlaceholder) {
          $(this).removeClass("placeholderInInput");
          $(this).val('');
        }
      });

      me.inp.blur(function () {
        if ($(this).val() == '') {
          $(this).addClass("placeholderInInput");
          $(this).val(me.filterPlaceholder);
        } else {
          $(this).removeClass("placeholderInInput");
        }
      });
    },

    // Событие клавиатуры.
    keyPress: function (e) {
      
      var me = e.data;
      var isVisible = me.results != null && me.results.is(':visible');

      if (me.inp.hasClass('disabled') || me.inp.attr('disabled')) return;

      if (isVisible) {
        if (/27$|38$|40$/.test(e.keyCode) || /9$|13$/.test(e.keyCode)) {

          e.preventDefault();
          e.stopPropagation();
          switch (e.keyCode) {
            case 38: // up
              // Если выбор не открыт, то откроем его и выделим текущую запись.
              me.goTo(isVisible ? -1 : 0);
              break;
            case 40: // down
              // Если выбор не открыт, то откроем его и выделим текущую запись.
              me.goTo(isVisible ? 1 : 0);
              break;
            case 9:  // tab
            case 13: // return
              me.selectCurrent();
              $('.rs_container').hide();
              break;
            case 27: // escape
              me.hide();
              break;
          }
        }
      } else {
        if (/38$|40$/.test(e.keyCode) && e.altKey) {
          me.show();
        }
      }
    },

    // Метод для перехода по элементам.
    goTo: function (direction) {
      var me = this;
      if (!me.results) return;
      var selEl = me.results.find('.rs_tr_over');
      var newEl;

      // Первый раз открываем c выбранной первой записью. 
      if (selEl.length == 0 && direction == 0) {
        selEl = me.results.find('tr:first');
        me.toggleSelected(selEl);
      } else {
        // Предыдущее значение.
        if (direction == -1) {
          newEl = selEl.prev();
          if (newEl.length == 0) {
            newEl = selEl.parent().find('tr:last');
          }
          me.toggleSelected(newEl);
        } else
          // Следующее значение.
          if (direction == 1) {
            newEl = selEl.next();
            if (newEl.length == 0) {
              newEl = selEl.parent().find('tr:first');
            }
            me.toggleSelected(newEl);
          }
      }
    },

    // Снимает выделение со всех значений, и устанавливает у переданного.
    toggleSelected: function (el) {
      el.parent().find('.rs_tr_over').removeClass('rs_tr_over');
      el.addClass('rs_tr_over');
    },

    // Показывает выбор значения.
    show: function () {
      var me = this;

      // Если не активен input, то не показываем выпадающее меню.
      if (me.inp.hasClass('Req_Disabled')) return;

      // Фильтр для отображения элементов списка.
      var keyFilter = null;
      var tmp = me.inp.data('filter');
      if (typeof tmp != 'undefined') {
        keyFilter = tmp.split(';');
        me.results = null;
      }

      if (!me.results) {
        var html = '<div class="rs_container stat_PickRequisiteResults"><div class="rs_results"><table cellspacing="0" cellpadding="2" class="rs_table"><tbody>';
        var hasItems = false;
        for (var i = 0, j = 0, c = me.keyvalues.length; i < c; i++) {
          if (me.keyvalues[i][0] != "-1") {
            if (keyFilter == null || (keyFilter != null && $.inArray(me.keyvalues[i][0], keyFilter) != -1)) {
              html += '<tr data-stataction="PickItem" class="' + (me.keyvalues[i][3] ? ' disabled' : '') + (j % 2 == 0 ? ' rs_tr_even' : ' rs_tr_odd') + '" data-key="' + me.keyvalues[i][0] + '" data-value="' + escapeHtml(me.keyvalues[i][1]) + '"><td class="rs_td">' + me.keyvalues[i][2] + '</td></tr>';
              hasItems = true;
              j++;
            }
          }
        }

        if (!hasItems) {
          html += '<tr class="rs_tr_even"><td class="rs_td error">' + L("NO_ITEMS_FOUND") + '</td></tr>';
        };

        html += '</table></tbody></div></div>';
        me.results = $(html).appendTo("body");

        if (hasItems) {
          // Навешиваем события на строки.
          me.results.find('tr:not(.disabled)')
            .hover(function () { $(this).addClass('rs_tr_over'); }, function () { $(this).parent().find('.rs_tr_over').removeClass('rs_tr_over'); })
            .unbind('click.DropDownList').bind('click.DropDownList', function () {
              me.selectCurrent(this);
            });
        }
      }

      // Устанавливаем положение выпадающего списка.
      me.setCoord();

      if (!me.results.is(':visible')) {

        $('.rs_container').hide();
        me.results.show();
      }
      me._isShown = true;
    },

    // Событие при выборе значения пользователем.
    selectCurrent: function (selectedEl) {
      var me = this;
      var el;
      if (selectedEl == null || typeof selectedEl == 'undefined') {
        el = me.results.find('.rs_tr_over');
      } else {
        el = $(selectedEl);
      }

      if (el.length == 1) {
        me.setValue(el.attr('data-key'));
      }
    },

    setInitValue: function () {
      return this.setValue(this.initValue);
    },

    setPrevValue: function () {
      return this.setValue(this.prevValue);
    },

    setValue: function (value, displayValue, opt_needTriggerResult) {
      var me = this;
      var needTriggerResult = (opt_needTriggerResult !== false); //по умолчанию события срабатывает, если поменялось значение.
      var valueIsChanged = false;

      if (typeof displayValue === 'undefined') {
        for (var i = 0; i < me.keyvalues.length; i++) {
          if (me.keyvalues[i][0] === value.escapeHtml()) {
            me.prevValue = me.hidd.val();

            me.inp.val(me.keyvalues[i][1]);
            me.hidd.val(value);

            valueIsChanged = true;
            
            break;
          }
        }
      } else {
        me.prevValue = me.hidd.val();
        me.inp.val(displayValue);
        me.hidd.val(value);
        valueIsChanged = true;
      }

      if (needTriggerResult && valueIsChanged) {
        me.inp.change(); //change вызываем явно, т.к. оно не вызывается при установке val(), а в мастерах действия навешивается это событие
        me.inp.removeClass("placeholderInInput");
        var v = me.hidd.val();
        if (me.onAfterChange) me.onAfterChange(v);
        me.inp.trigger('result', [v]);
      }

      return this;
    },

    getValue: function () {
      return this.hidd.val();
    },

    getDisplayValue: function () {
      var me = this;
      if (me.inp.hasClass('placeholderInInput')) {
        return '';
      } else {
        return me.inp.val();
      }
    },
 
    clearDropDownListItems: function () {
      this.keyvalues = [];
      if (!!this.results) this.results.remove();
      this.results = null;
      return this;
    },


    addDropDownListItem: function (item) {
      this.keyvalues.push(item);
      if (!!this.results) this.results.remove();
      this.results = null;
      return this;
    },

    removeDropDownListItem: function (key) {
      var me = this;
      for (var i = 0; i < me.keyvalues.length; i++) {
        if (me.keyvalues[i][0] === key) {
          me.keyvalues[i][0] = '-1';
          if (!!this.results) this.results.remove();
          this.results = null;
          break;
        }
      }
      return this;
    },

    // Скрывает выбор значения.
    hide: function () {
      if (this.results) this.results.hide();
      this._isShown = false;
      return this;
    },

    disable: function () {
      this.inp.addClass('Req_Disabled');
      return this;
    },

    enable: function () {
      this.inp.removeClass('Req_Disabled');
      return this;
    },

    setCoord: function () {
      var me = this;
      var c = me.inp;

      var top = c.offset().top + c.height() + 6;
      var height = me.results.outerHeight();
      var wh = $(window).height();
      if ((top + height) > wh) {
        top = c.offset().top - height - 1;
        if (top < 0) top = 0;
      }

      me.results.css({
        left: (c.offset().left + 1),
        top: top,
        width: Math.max(c.width() - 10, 130),
        minWidth: me.inp.outerWidth(true) - 5
      });
    }

  };

  // Регистрируем плагин jQuery.
  $.fn.extend({
    DropDown: function (img, hidd, keyvalues, opt) {
      this.data('DropDownListInstance', new DropDownList($(this), img, hidd, keyvalues, opt));
      this.trigger('Init');
      return this;
    },
    HidePickContainer: function () {
      this.data('DropDownListInstance').hide();
      return this;
    }
  });
})(jQuery);
